export function withBase(path = '') {
    const base = process.env.BASE_URL || '/';
    const stripEnd = (s) => s.replace(/\/+$/, '');
    const stripStart = (s) => s.replace(/^\/+/, '');
    return `${stripEnd(base)}/${stripStart(path)}`;
}
